import { render, staticRenderFns } from "./NewProductText.vue?vue&type=template&id=699f7924&functional=true"
import script from "./NewProductText.vue?vue&type=script&lang=js"
export * from "./NewProductText.vue?vue&type=script&lang=js"
import style0 from "./NewProductText.vue?vue&type=style&index=0&id=699f7924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports